import { render } from "./AppStatusbar.vue?vue&type=template&id=d666c8be&scoped=true"
import script from "./AppStatusbar.vue?vue&type=script&lang=ts"
export * from "./AppStatusbar.vue?vue&type=script&lang=ts"

import "./AppStatusbar.vue?vue&type=style&index=0&id=d666c8be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d666c8be"

export default script
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
